export enum UserProfileActionType {
  FETCH_USER_PROFILE = "fetch_user_profile",
  FETCH_USER_PROFILE_SUCCESS = "fetch_user_profile_success",
  FETCH_USER_PROFILE_FAILURE = "fetch_user_profile_failure",
  UPDATE_USER_PROFILE = "update_user_profile",
  UPDATE_USER_PROFILE_SUCCESS = "update_user_profile_success",
  UPDATE_USER_PROFILE_FAILURE = "update_user_profile_failure",
}
